var _path, _circle, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaIconTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 164,
    viewBox: "0 0 163 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80508 123.561L12.3236 21.3391C13.1874 10.9732 21.8527 3 32.2545 3H113.968C124.369 3 133.035 10.9732 133.899 21.3391L142.417 123.561C143.389 135.222 134.187 145.222 122.486 145.222H23.736C12.0352 145.222 2.83338 135.222 3.80508 123.561Z",
    fill: "#F9A749",
    stroke: "#191B45",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126.556,
    cy: 127.556,
    r: 35.5556,
    fill: "#191B45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 126.42L123.889 134.815L138.704 120",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5257 26.7037C49.5257 26.7037 46.5628 56.3334 70.2665 56.3334C93.9702 56.3334 91.0045 26.7037 91.0045 26.7037",
    stroke: "#191B45",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaIconTwo);
export default __webpack_public_path__ + "static/media/fea_icon_two.42b6d89a66f104cbf6c9b302ec536f03.svg";
export { ForwardRef as ReactComponent };